import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import "../assets/styles.css";

const IndexPage = props => {
  const siteTitle = "Victor Sanchez";
  const iconsHeader = [
    {
      key: 1,
      title: "Microsoft Dynamics CRM",
      icon: `<svg
  xmlns="http://www.w3.org/2000/svg"
  x="0px"
  y="0px"
  width="50"
  height="50"
  viewBox="0 0 50 50"
  style={{ fill: "#ffffff" }}
>
  <g id="surface1" stroke="#fff">
    <path fill="#fff"
      d="M 23.96875 4 C 23.523438 4.015625 23.136719 4.324219 23.03125 4.757813 C 23.03125 4.757813 21.53125 10.796875 18.183594 18.148438 C 14.835938 25.5 9.636719 34.105469 2.421875 39.183594 C 2.15625 39.371094 2 39.675781 2 40 L 2 44.777344 C 1.90625 45.175781 2.066406 45.59375 2.40625 45.828125 C 2.429688 45.847656 2.457031 45.863281 2.484375 45.878906 C 2.5 45.886719 2.519531 45.894531 2.535156 45.90625 C 2.546875 45.910156 2.5625 45.917969 2.574219 45.921875 C 2.574219 45.925781 2.578125 45.925781 2.578125 45.925781 C 2.816406 46.027344 3.082031 46.039063 3.324219 45.949219 C 3.503906 45.902344 14.347656 43 26 43 C 37.75 43 46.6875 45.949219 46.6875 45.949219 C 46.992188 46.050781 47.324219 46 47.585938 45.8125 C 47.847656 45.621094 48 45.320313 48 45 L 48 18 C 48 17.730469 47.890625 17.472656 47.695313 17.28125 C 47.503906 17.09375 47.242188 16.992188 46.96875 17 C 46.679688 17.007813 46.402344 17.144531 46.21875 17.375 C 43.453125 20.804688 40.308594 23.761719 37 26.3125 L 37 11 C 37 10.730469 36.890625 10.472656 36.695313 10.28125 C 36.503906 10.09375 36.242188 9.992188 35.96875 10 C 35.550781 10.011719 35.183594 10.285156 35.050781 10.6875 C 35.050781 10.6875 34.503906 12.363281 32.75 15.171875 C 31.210938 17.632813 28.761719 20.910156 25 24.503906 L 25 5 C 25 4.730469 24.890625 4.472656 24.695313 4.285156 C 24.503906 4.09375 24.242188 3.992188 23.96875 4 Z M 23 11.269531 L 23 26.605469 C 22.972656 26.738281 22.972656 26.878906 23 27.015625 L 23 33.296875 C 21.910156 33.589844 12.402344 36.359375 4 43.058594 L 4 40.449219 C 11.457031 35 16.648438 26.351563 20.003906 18.976563 C 21.367188 15.984375 22.210938 13.539063 23 11.269531 Z M 35 15.140625 L 35 28.125 C 34.972656 28.253906 34.972656 28.386719 35 28.515625 L 35 37 C 32.933594 36.960938 22.191406 36.910156 11.859375 40.082031 C 18.359375 36.515625 24.25 34.96875 24.25 34.96875 C 24.691406 34.855469 25 34.457031 25 34 L 25 27.222656 C 29.667969 23.019531 32.640625 19.117188 34.445313 16.230469 C 34.855469 15.574219 34.703125 15.6875 35 15.140625 Z M 46 20.53125 L 46 43.722656 C 44.296875 43.199219 36.789063 41 26 41 C 20.972656 41 16.15625 41.53125 12.183594 42.144531 C 23.460938 38.703125 35.96875 39 35.96875 39 C 36.238281 39.007813 36.5 38.90625 36.695313 38.71875 C 36.890625 38.53125 37 38.269531 37 38 L 37 28.796875 C 40.1875 26.449219 43.207031 23.65625 46 20.53125 Z "
    />
  </g>
</svg>`
    },
    {
      key: 2,
      title: "Microsoft Azure",
      icon: `<svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      style={{ enableBackground: "new 0 0 48 48", fill: "#fff" }}
    >
      <g stroke="#fff">
        <polygon
        style="fill: #fff"
          points="46,40 29.317,10.852 22.808,23.96 34.267,37.24 13,39.655 	"
        />
        <polygon
          style="fill: #fff"
          points="13.092,18.182 2,36.896 11.442,35.947 28.033,5.678 	"
        />
      </g>
    </svg>`
    },
    {
      key: 3,
      title: "Javascript",
      icon: `<svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      style={{ fill: "#fff" }}
    >
      <g id="surface1" stroke="#fff">
        <path fill="#fff"
          d="M 6.667969 4 C 5.207031 4 4 5.207031 4 6.667969 L 4 43.332031 C 4 44.792969 5.207031 46 6.667969 46 L 43.332031 46 C 44.792969 46 46 44.796875 46 43.332031 L 46 6.667969 C 46 5.207031 44.796875 4 43.332031 4 Z M 6.667969 6 L 43.332031 6 C 43.703125 6 44 6.296875 44 6.667969 L 44 43.332031 C 44 43.703125 43.703125 44 43.332031 44 L 6.667969 44 C 6.296875 44 6 43.703125 6 43.332031 L 6 6.667969 C 6 6.296875 6.296875 6 6.667969 6 Z M 23 23 L 23 35.574219 C 23 37.503906 22.269531 38 21 38 C 19.671875 38 18.75 37.171875 18.140625 36.097656 L 15 38 C 15.910156 39.925781 18.140625 42 21.234375 42 C 24.65625 42 27 40.179688 27 36.183594 L 27 23 Z M 35.453125 23 C 32.046875 23 29.863281 25.179688 29.863281 28.042969 C 29.863281 31.148438 31.695313 32.617188 34.449219 33.789063 L 35.402344 34.199219 C 37.140625 34.960938 38 35.425781 38 36.734375 C 38 37.824219 37.171875 38.613281 35.589844 38.613281 C 33.707031 38.613281 32.816406 37.335938 32 36 L 29 38 C 30.121094 40.214844 32.132813 42 35.675781 42 C 39.300781 42 42 40.117188 42 36.683594 C 42 33.496094 40.171875 32.078125 36.925781 30.6875 L 35.972656 30.28125 C 34.335938 29.570313 33.625 29.109375 33.625 27.964844 C 33.625 27.039063 34.335938 26.328125 35.453125 26.328125 C 36.550781 26.328125 37.253906 26.792969 37.90625 27.964844 L 40.878906 26.058594 C 39.625 23.84375 37.878906 23 35.453125 23 Z "
        />
      </g>
    </svg>`
    },
    {
      key: 4,
      title: "React",
      icon: `
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 32 32" style={{ fill: "#fff" }}><g transform="matrix(.05696 0 0 .05696 .647744 2.43826)" fill="none" fill-rule="evenodd"><circle r="50.167" cy="237.628" cx="269.529" fill="#fff"/><g stroke="#fff" stroke-width="24"><path d="M269.53 135.628c67.356 0 129.928 9.665 177.107 25.907 56.844 19.57 91.794 49.233 91.794 76.093 0 27.99-37.04 59.503-98.083 79.728-46.15 15.29-106.88 23.272-170.818 23.272-65.554 0-127.63-7.492-174.3-23.44-59.046-20.182-94.61-52.103-94.61-79.56 0-26.642 33.37-56.076 89.415-75.616 47.355-16.51 111.472-26.384 179.486-26.384z"/><path d="M180.736 186.922c33.65-58.348 73.28-107.724 110.92-140.48C337.006 6.976 380.163-8.48 403.43 4.937c24.248 13.983 33.042 61.814 20.067 124.796-9.8 47.618-33.234 104.212-65.176 159.6-32.75 56.788-70.25 106.82-107.377 139.272-46.98 41.068-92.4 55.93-116.185 42.213-23.08-13.3-31.906-56.92-20.834-115.233 9.355-49.27 32.832-109.745 66.8-168.664z"/><path d="M180.82 289.482C147.075 231.2 124.1 172.195 114.51 123.227c-11.544-59-3.382-104.11 19.864-117.566 24.224-14.024 70.055 2.244 118.14 44.94 36.356 32.28 73.688 80.837 105.723 136.173 32.844 56.733 57.46 114.21 67.036 162.582 12.117 61.213 2.31 107.984-21.453 121.74-23.057 13.348-65.25-.784-110.24-39.5-38.013-32.71-78.682-83.253-112.76-142.115z"/></g></g></svg>
   `
    }
  ];

  const pcfs = [
    {
      key: 1,
      href: "https://github.com/victorsolaya/PCF-On-Key-Press",
      name: "On Key Press control"
    },
    {
      key: 2,
      href: "https://github.com/victorsolaya/Multiselect_Records_PCF",
      name: "Multiselect Records"
    },
    {
      key: 3,
      href: "https://github.com/victorsolaya/CardViewer",
      name: "Card Viewer"
    },
    {
      key: 4,
      href: "https://github.com/victorsolaya/progress-control-pcf",
      name: "Progress Control"
    }
  ];

  const certifications = [
    {
      key: 1,
      name: "Microsoft® Certified Solutions Expert: Business Applications"
    },
    { key: 2, name: "Microsoft® Certified Solutions Associate: Dynamics 365" },
    { key: 3, name: "MCT (Microsoft Certified Trainer)" }
  ];

  const conferences = [
    {
      key: 1,
      name: "Dynamics 365 Saturday Madrid",
      location: "Madrid",
      href: "https://www.youtube.com/watch?v=ety6rVC81ZA"
    }
  ];
  return (
    <Layout location={props.location} title={siteTitle} lang="en">
      <SEO
        title="Home"
        keywords={[
          `blog`,
          `gatsby`,
          `javascript`,
          `react`,
          `victorsolaya`,
          `axazure`,
          `dynamics 365`,
          `dynamics crm`
        ]}
      />

      <div>
        <p className="title">About me</p>
        <div className="--card">
          <span className="titleBio">Summary</span>
          <p className="divider"></p>
          <div className="iconsBio">
            {iconsHeader.map(iconHeader => {
              return (
                <p key={iconHeader.key} title={iconHeader.title}>
                  <p dangerouslySetInnerHTML={{ __html: iconHeader.icon }}></p>
                  <span>{iconHeader.title}</span>
                </p>
              );
            })}
          </div>
          <p className="bio">
            I currently work as a Dynamics 365 Consultant at{" "}
            <a href="https://www.axazure.com/">Axazure</a> specialising in both
            Dynamics 365 and Javascript development. Implementing the best needs
            for the customer alongside the best performance is one of the
            priorities I have.
            <br />
          </p>
          <p className="bio separator">
            I have some useful snippets in my utilities that you can freely take
            for you if you need them.
            <br />I will be working in a blog as well to share with you what I
            find and some insights that I can take from my experience in CRM
            <br />
            Please, feel free to drop me a message if you have any questions.
          </p>
          <p className="bio separator">
            Apart from that, I have the opportunity to create some PCFs for the
            community called:
          </p>

          <ul style={{ margin: "5px" }}>
            {pcfs.map(pcf => {
              return (
                <li
                  key={pcf.key}
                  style={{
                    listStyle: "none",
                    paddingLeft: "2rem",
                    color: "white"
                  }}
                >
                  <svg
                    style={{
                      marginRight: "1rem",
                      width: "16px",
                      height: "16px"
                    }}
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="check-square"
                    className="svg-inline--fa fa-check-square fa-w-14 "
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="currentColor"
                      d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                    ></path>
                  </svg>
                  <a
                    href={pcf.href}
                    target=" _blank"
                    rel="noreferrer"
                    style={{
                      color: "white",
                      paddingBottom: "5px",
                      borderBottom: "1px solid white"
                    }}
                  >
                    {pcf.name}
                  </a>
                </li>
              );
            })}
          </ul>
          <p className="bio separator">
            My latests projects I have been working on required many
            customizations with Dynamics CRM 365, Azure, Javascript and C#.
          </p>

          <span className="titleBio">Conferences</span>
          <p className="divider"></p>
          <p className="bio separator">
            Conferences are a great point to learn and share knowledge, at the
            moment I have only spoken for one conference (in Spanish):
          </p>
          <ul className="conferences">
            {conferences.map(conference => {
              return (
                <li key={conference.key} className="conference">
                  <svg
                    style={{
                      marginRight: "1rem",
                      width: "16px",
                      height: "16px"
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 3a1 1 0 00-1.447-.894L8.763 6H5a3 3 0 000 6h.28l1.771 5.316A1 1 0 008 18h1a1 1 0 001-1v-4.382l6.553 3.276A1 1 0 0018 15V3z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <a href={conference.href} target="_blank" rel="noreferrer">
                    {conference.name}
                  </a>
                  .
                </li>
              );
            })}
          </ul>
          <span className="titleBio">Dynamics CRM 365</span>
          <p className="divider"></p>
          <p className="bio separator">
            Dynamics CRM 365 is the tool I have been working since I started my
            career in 2016. I have worked in many projects developing the best
            needs for the customer and implementing the requirements and
            customizations they could ask or we suggested to make their job
            easier and better. Working with this tool made me focus on many
            Javascript and C# customizations to increase the performance and
            usability of the projects we had. I have been working with the
            Portal Add-On of Dynamics CRM and implementing requirements in Azure
            with C#.
          </p>
          <span className="titleBio">Personal Projects</span>
          <p className="divider"></p>
          <p className="bio separator">
            I have been using Vue.Js and Nuxt.Js for some projects I have been
            working on with some backend code stored in Firebase. Besides, I
            have been learning some bits about React, since all the PCFs have
            been done using React and, of course, this page has been made with
            GatsbyJS, framework that uses React. If you want to know more about
            this, drop me a message
            <a href="mailto:me@victorsolaya.com"> here</a>.
          </p>
          <span className="titleBio">Certifications</span>
          <p className="divider"></p>
          <p className="bio">I hold some Microsoft Certifications as:</p>
          <ul className="certifications">
            {certifications.map(certification => {
              return (
                <li key={certification.key} className="certification">
                  <svg
                    style={{
                      marginRight: "1rem",
                      width: "16px",
                      height: "16px"
                    }}
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="certificate"
                    className="svg-inline--fa fa-certificate fa-w-16 "
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
                    ></path>
                  </svg>
                  {certification.name}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="--card downcard">
          <span className="titleBio">Contact</span>
          <p className="divider"></p>
          <p className="bio">
            Do you want to know more about me? Then drop me an email at
            <a href="mailto:me@victorsolaya.com"> me@victorsolaya.com</a>
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
